<template>
  <button class="nextbutton btn button" v-on:click="onSubmit">
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  props: { text: String },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit("next");
    },
  },
};
</script>
<style>
.nextbutton {
  border-radius: 4px;
  border: none;
  background-color: #db9c94 !important;
  text-align: center;
  width: 125px !important;
  transition: all 0.5s;
  padding: 10px !important;
  cursor: pointer;
}

.nextbutton span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
  color: black;
}

.nextbutton span:after {
  content: "\00bb";
  position: absolute;
  opacity: 0;
  top: 0;
  transition: 0.5s;
}

.nextbutton:hover span {
  padding-right: 25px;
}

.nextbutton:hover span:after {
  opacity: 1;
  right: 0;
}
</style>
